<style scope></style>

<template>
  <div class="columns">
    <div class="column">
      <b-table :data="lista" :loading="loading" class="row-button"
               >
        <portal-lista-vazia slot="empty"/>

        <template slot-scope="props">

          <b-table-column label="Mês">
            {{ props.row.MES | moment("MMMM") }}
          </b-table-column>

          <b-table-column label="Ano">
            {{ props.row.ANO }}
          </b-table-column>

          <b-table-column label="Comissão" numeric>
            {{ props.row.E3_COMIS | moeda }}
          </b-table-column>

        </template>

      </b-table>
    </div>

    <div class="column">
      <portal-box>
        <template slot="titulo">
          <h1 class="title is-4">Comissão</h1>
          <h3 class="subtitle is-6">Demonstrativo em {{ dia | moment("dddd, DD MMMM HH:mm") }}.</h3>
        </template>

        <portal-loading-small :loading="loading" class="p-h-xl" />

        <template v-if="!loading">

          <section class="animated fadeIn">
            <grafico-linha :chart-data="dadosComissao" :height="300" :width="600"/>
          </section>

        </template>

      </portal-box>
    </div>

  </div>
</template>

<script>
  import GraficoLinha from '../../graficos/GraficoLinha'

  export default {
    components: {GraficoLinha},
    props: ['lista', 'loading'],
    data () {
      return {
        dia: new Date(),
        comissoes: [],
        dadosComissao: null
      }
    },
    created () {
      this.buildMetas()
    },
    methods: {
      buildMetas () {
        this.dia = new Date()
        this.comissoes = this.lista
        if (this.comissoes && this.comissoes.length > 0) {
          let labels = this.comissoes.map(c => c.label)
          let comissoes = this.comissoes.map(c => c.E3_COMIS)
          this.dadosComissao = {
            labels: labels,
            datasets: [
              {
                label: 'Mês/Ano',
                backgroundColor: [
                  'rgba(128, 32, 0, 0.5)'
                ],
                borderColor: [
                  'rgba(128, 32, 0, 1)'
                ],
                borderWidth: 1,
                data: comissoes
              }
            ]
          }
        }
      }
    },
    watch: {
      lista (value) {
        this.buildMetas()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/comissao/ListaComissaoSintetica.vue